// SceneLoader.js
var SceneLoader = pc.createScript('sceneLoader');


SceneLoader.attributes.add('rootSceneId', { type: 'number' });
SceneLoader.attributes.add('rootWorldWrapper', { type: 'entity' });
SceneLoader.attributes.add('player', { type: 'entity' });
SceneLoader.attributes.add('camEntity', { type: 'entity' });

// initialize code called once per entity
SceneLoader.prototype.initialize = function() {
    this.app.on('sceneLoader:loadScene', this.loadScene, this);
};


SceneLoader.prototype.loadScene = function(id) {

    //PickerRaycast.prototype.showRoot(false);
    var that = this;
    var path = id+'.json';
    
    //load new scene
    if(this.currentLoadedSceneId !== id) {
        this.currentLoadedSceneId = id;
        
        //remove old scene content if available
        for (var i = 0; i < this.app.root.children.length; i++) {
            if(this.app.root.children[i].name === 'Root') {
                this.app.root.children[i].destroy();
            }
        }
        
        if(this.rootSceneId !== id) {
            this.app.loadSceneHierarchy(path, function (err, entity) {
                
                that.app.loadSceneSettings(path, function(err) {
                    if (!err) {
                        var newSceneCam = that.app.root.findByName('Camera');
                        if(newSceneCam) {
                            
                            newSceneCam.enabled = false;
                            
                            //setting the targetCam attributes to the VRCamera
                            that.camEntity.camera.clearColor = newSceneCam.camera.clearColor;
                            that.camEntity.camera.nearClip = newSceneCam.camera.nearClip;
                            that.camEntity.camera.farClip = newSceneCam.camera.farClip;
                        }
                        
                        //that.app.lightmapper.bake();
                        
                    } else {
                        console.error('loadSceneSettings', err);
                    }
                });
                that.setSpawn(that, entity.findByTag('spawn')[0]);
            });    
        }
    }

    
    if(this.rootSceneId === id) {
        //console.log('show root world');
        this.rootWorldWrapper.enabled = true;
        that.setSpawn(that, that.app.root.findByTag('spawn')[0]);
        
    } else {
        //console.log('hide root world');
        this.rootWorldWrapper.enabled = false;
    }
};

SceneLoader.prototype.setSpawn = function(that, entity) {
    var spawnPosition = entity.getPosition();
    //console.log('spawnPosition', spawnPosition.name, spawnPosition.getPosition());
    that.player.setPosition(spawnPosition.x, that.player.getPosition().y, spawnPosition.z);
    that.player.setLocalRotation(0,1,1,0);
};

